import { Lead } from "../Lead/Lead.js";
const lead = new Lead();
window.lead = lead;

import { TruckCalculator } from '../Calculator/truck-calculator.es.js'
window.TruckCalculator = TruckCalculator;

// Resize
$(window).on("resize", function () {
	//if (container) container.getBoundingClientRect();
});

// Scroll
$(window).on("scroll", function () {});

// Document click
$(document).on("click", function (e) {
	//console.log(e.target)
});

// popups
$(".popup__close, .popup__cancel").on("click", function (e) {
	$("body").removeClass("no-scroll");
	$(this).closest(".popup").removeClass("active");
});

$(".popup").on("click", function (e) {
	var callbackPopup = $(".popup__card");
	if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
		$(this).removeClass("active");
		$("body").removeClass("no-scroll");
	}
});

$("[data-popup-open]").on("click", function (e) {
	e.preventDefault();
	$(this).closest(".popup").removeClass("active"); //удаляем класс active у ранее открытого попапа
	let dataPopupName = $(this).attr("data-popup-open");
	let popup = $(".popup[data-popup-name=" + dataPopupName + "]");
	//-console.log("popup Open", popup);
	$("body").addClass("no-scroll");
	popup.addClass("active");
});

//burger
$(".header-nav__toggler").on("click", function (e) {
	e.preventDefault();

	let burgerName = $(this).attr("data-burger-open");
	let burger = $(".header__nav[data-burger-name=" + burgerName + "]");
	if ($(this).hasClass("active")) {
		$(this).removeClass("active");
		burger.removeClass("active");
		$("body").removeClass("no-scroll");
	} else {
		$(this).addClass("active");
		burger.addClass("active");
		$("body").addClass("no-scroll");
	}
});

//sidebar
$("[data-sidebar-open]").on("click", function (e) {
	e.preventDefault();
	let dataSidebarName = $(this).attr("data-sidebar-open");
	let sidebar = $(
		".header__sidebar[data-sidebar-name=" + dataSidebarName + "]"
	);
	if ($(this).hasClass("active")) {
		$(this).removeClass("active");
		$("body").removeClass("no-scroll");
		sidebar.removeClass("active");
	} else {
		$(this).addClass("active");

		$("body").addClass("no-scroll");
		sidebar.addClass("active");
	}
});

$(".sidebar__item").on("click", function (e) {
	// Проверяем, является ли целевой элемент ссылкой
	if (!$(e.target).is("a")) {
		e.preventDefault();
	}
	//закрыть открытые, удалить аттрибут "open"
	$(".sidebar__item").not(this).find("details").removeAttr("open");
	$(this).find("details").attr("open", "open");
	console.log(this, " this 1", $(".sidebar__item").not(this).find("details"));
	console.log(this, " this 5", $(this).find("details"));
});

/*const details = document.querySelectorAll("details");

// добавить к каждому клику события клика
[...details].forEach((targetDetail) => {
	targetDetail.addEventListener("click", (_) => {
		// закрывать всех кроме кликнутого
		details.forEach((detail) => {
			if (detail !== targetDetail) {
				detail.removeAttribute("open");
			}
		});
	});
});*/

//open/close accordion
document.addEventListener("DOMContentLoaded", function () {
	const list = document.querySelector(".questions__list");

	if (!list) return;

	list.addEventListener("click", function (event) {
		const acc = event.target.closest(".accordion");
		if (!acc) return;

		event.preventDefault();
		acc.classList.toggle("active");

		const panel = acc.nextElementSibling;
		if (panel && panel.classList.contains("panel")) {
			if (panel.style.maxHeight) {
				panel.style.maxHeight = null;
				panel.style.marginTop = 0;
			} else {
				panel.style.maxHeight = panel.scrollHeight + "px";
				panel.style.marginTop = "10px";
			}
		}
	});
});

$(document).ready(function() {
	if ($('.media-swiper').length) {
		var swiper = new Swiper('.media-swiper', {
			slidesPerView: "1",
			spaceBetween: 16,
			navigation: {
				nextEl: '.media-swiper-btn-next',
				prevEl: '.media-swiper-btn-prev',
			},
			breakpoints: {
				480: {
					slidesPerView: "2",
					// spaceBetween: 20,
				},
				576: {
					slidesPerView: "3",
					// spaceBetween: 20,
				},
				1024: {
					slidesPerView: "4",
				},
				1440: {
					slidesPerView: "5",
				},
			},
		});
	} else {
		console.warn('Swiper ".media-swiper" не найден на странице');
	}
});

$(document).ready(function() {
	if ($('.popular-swiper').length) {
		var swiper = new Swiper('.popular-swiper', {
			slidesPerView: "1",
			spaceBetween: 16,
			navigation: {
				nextEl: '.popular-swiper-btn-next',
				prevEl: '.popular-swiper-btn-prev',
			},
			breakpoints: {
				480: {
					slidesPerView: "2",
					// spaceBetween: 20,
				},
				576: {
					slidesPerView: "3",
					// spaceBetween: 20,
				},
				1024: {
					slidesPerView: "4",
				}
			},
		});
	} else {
		console.warn('Swiper ".popular-swiper" не найден на странице');
	}
});

//add swiper
var swiper = new Swiper(".gallery__swiper", {
	modules: [Navigation],
	//speed: 400,
	slidesPerView: 2,
	/*autoplay: {
		delay: 5000,
	},*/
	direction: "horizontal",
	//direction: getDirection(),
	breakpoints: {
		480: {
			slidesPerView: 2,
		},
		768: {
			slidesPerView: 2,
		},
		992: {
			slidesPerView: 3,
		},
		1200: {
			slidesPerView: 3,
		},
		1600: {
			slidesPerView: 3,
		},
	},
	navigation: {
		nextEl: ".gallery__swiper-button-next",
		prevEl: ".gallery__swiper-button-prev",
	},
});

var swiper2 = new Swiper(".recommend__swiper", {
	modules: [Navigation],
	slidesPerView: 2,
	direction: "horizontal",
	breakpoints: {
		480: {
			slidesPerView: 2,
		},
		768: {
			slidesPerView: 3,
		},
		992: {
			slidesPerView: 3,
		},
		1200: {
			slidesPerView: 4,
		},
		1600: {
			slidesPerView: 4,
		},
	},
	navigation: {
		nextEl: ".recommend__swiper-button-next",
		prevEl: ".recommend__swiper-button-prev",
	},
});

var swiper3 = new Swiper(".product__swiper", {
	modules: [Navigation, Pagination],
	slidesPerView: 1,
	direction: "horizontal",
	spaceBetween: 30,
	pagination: {
		el: ".swiper-pagination",
		clickable: true,
	},
});

const productPage = document.querySelector(".product-page");
if (productPage) {
	let productNavSlider = new Swiper(".product-nav__slider", {
		//spaceBetween: 1,
		slidesPerView: 3,
		slideToClickedSlide: true,
		keyboard: {
			enabled: true,
			onlyInViewport: true,
			pageUpDown: true,
		},
		breakpoints: {
			480: {
				direction: "vertical",
			},
		},
	});

	let productPageSlider = new Swiper(".product-page__slider", {
		modules: [Navigation, Thumbs],
		spaceBetween: 5,
		slidesPerView: 1,
		slideToClickedSlide: true,
		keyboard: {
			enabled: true,
			onlyInViewport: true,
			pageUpDown: true,
		},
		thumbs: {
			swiper: productNavSlider,
		},
		breakpoints: {
			480: {
				direction: "vertical",
			},
		},
	});

	// Добавление обработчика события mouseover для смены слайда
	productNavSlider.slides.forEach((slide, index) => {
		slide.addEventListener("mouseover", () => {
			productPageSlider.slideTo(index);
		});
	});
}

//phone mask
window.addEventListener("DOMContentLoaded", function () {
	[].forEach.call(document.querySelectorAll(".tel"), function (input) {
		var keyCode;
		function mask(event) {
			event.keyCode && (keyCode = event.keyCode);
			var pos = this.selectionStart;
			if (pos < 3) event.preventDefault();
			var matrix = "+7 (___)-___-__-__",
				i = 0,
				def = matrix.replace(/\D/g, ""),
				val = this.value.replace(/\D/g, ""),
				new_value = matrix.replace(/[_\d]/g, function (a) {
					return i < val.length ? val.charAt(i++) || def.charAt(i) : a;
				});
			i = new_value.indexOf("_");
			if (i != -1) {
				i < 5 && (i = 3);
				new_value = new_value.slice(0, i);
			}
			var reg = matrix
				.substr(0, this.value.length)
				.replace(/_+/g, function (a) {
					return "\\d{1," + a.length + "}";
				})
				.replace(/[+()]/g, "\\$&");
			reg = new RegExp("^" + reg + "$");
			if (
				!reg.test(this.value) ||
				this.value.length < 5 ||
				(keyCode > 47 && keyCode < 58)
			)
				this.value = new_value;
			if (event.type == "blur" && this.value.length < 5) this.value = "";
		}

		input.addEventListener("input", mask, false);
		input.addEventListener("focus", mask, false);
		input.addEventListener("blur", mask, false);
		input.addEventListener("keydown", mask, false);
	});
});

// подключаем select сортировки главной страницы
jQuery(function($) {
	let popularSwiper;
	let swiperInited = false;

	function initPopularSwiper() {
		const container = document.querySelector('.popular-swiper');
		if (!container) return;
	
		// всегда убираем старый класс, чтобы не копился
		container.classList.remove('swiper-disabled');
	
		const slides = container.querySelectorAll('.swiper-slide');
		const slideCount = slides.length;
	
		let slidesPerView = 1;
		const width = window.innerWidth;
		if (width >= 1024) slidesPerView = 4;
		else if (width >= 576) slidesPerView = 3;
		else if (width >= 480) slidesPerView = 2;
	
		if (slideCount <= slidesPerView) {
			container.classList.add('swiper-disabled'); // 🧷 Важно: вешаем всегда вручную
			return;
		}
	
		popularSwiper = new Swiper(container, {
			slidesPerView: "1",
			spaceBetween: 16,
			navigation: {
				nextEl: '.popular-swiper-btn-next',
				prevEl: '.popular-swiper-btn-prev'
			},
			breakpoints: {
				480: { slidesPerView: "2" },
				576: { slidesPerView: "3" },
				1024: { slidesPerView: "4" }
			},
			// 🔒 запрещаем перетаскивание мышью
			allowTouchMove: window.innerWidth < 1024
		});		
	}	

	initPopularSwiper();

	$(".select").on("click", ".select__head", function() {
		const filters = $(this).parent().parent().offset();
		const selectId = $(this).attr("data-id");
		const rect = this.getBoundingClientRect();

		if ($(this).hasClass("open")) {
			$(this).removeClass("open");
			$(".select__list").fadeOut();
		} else {
			$(".select__head").removeClass("open");
			$(".select__list").fadeOut();
			$(this).addClass("open");
			let $list = $(".select__list").filter(`[data-id="${selectId}"]`);
			$list.css({ left: (rect.left - filters.left) + "px" }).fadeIn();
		}
	});

	$(document).click(function(e) {
		if (!$(e.target).closest(".select").length) {
			$(".select__head").removeClass("open");
			$(".select__list").fadeOut();
		}
	});

	$(".select__list").on("click", ".select__button", function(e) {
		e.preventDefault();
		const $button = $(this);
		const $item = $button.closest(".select__item");
		const itemValue = $item.attr("data-value");
		const itemText = $button.text().trim();

		if (typeof itemValue === "undefined") return;

		$(".select__head").removeClass("open");
		$item.parent().fadeOut();

		const itemId = $item.parent().attr("data-id");
		const $head = $(`.select__head[data-id="${itemId}"]`);
		$head.text(itemText);

		const $select = $head.closest(".select");
		const $input = $select.find("input.select__input");
		if ($input.length) $input.val(itemValue);

		$("#select-popular__form").trigger("submit");
	});

	$("#select-popular__form").on("submit", function(e) {
		e.preventDefault();
		const form = $(this);

		if (popularSwiper?.destroy) {
			popularSwiper.destroy(true, true);
			popularSwiper = null;
		}

		$.ajax({
			type: "POST",
			url: "/ajax.php?mid=1",
			dataType: "html",
			data: form.serialize() + "&action=loadItems",

			beforeSend: function() {
				$(".popular__list").hide();
				$("#spinner").fadeIn(200);
			},

			success: function(data) {
				let $newContent = $(data).find('.popular__list').html();
				if ($newContent) {
					$(".popular__list").html($newContent);
				} else {
					$(".popular__list").replaceWith(data);
				}

				let selectedCategory = $("input[name='slt_cats']").val();
				let selectedTonn = $("input[name='str_tonn']").val();
				let selectedBrand = $("input[name='slt_brands']").val();
				let tonnNum = parseFloat(selectedTonn.replace(",", ".").replace(/[^\d.]/g, ""));

				// фильтрация карточек
				if (selectedCategory) {
					$(".popular__list a.product-card").each(function() {
						if ($(this).attr("data-cat") !== selectedCategory) {
							$(this).closest("li, .swiper-slide").remove();
						}
					});
				}

				if (selectedTonn) {
					$(".popular__list a.product-card").each(function() {
						let cardTonn = parseFloat($(this).attr("data-tonn")?.replace(",", ".").replace(/[^\d.]/g, ""));
						if (!isNaN(cardTonn) && cardTonn !== tonnNum) {
							$(this).closest("li, .swiper-slide").remove();
						}
					});
				}

				if (selectedBrand) {
					$(".popular__list a.product-card").each(function() {
						if ($(this).attr("data-brand") !== selectedBrand) {
							$(this).closest("li, .swiper-slide").remove();
						}
					});
				}

				const $slides = $(".popular__list .swiper-slide");
				const $swiperContainer = $(".popular-swiper");
				const $prev = $swiperContainer.find(".swiper-button-prev");
				const $next = $swiperContainer.find(".swiper-button-next");

				if ($slides.length === 0) {
					$(".popular__list").html('<div class="no-results"><p>Ничего не найдено</p></div>');
					$prev.hide();
					$next.hide();
					$swiperContainer.addClass("swiper-disabled");
				} else {
					$prev.css("display", "flex");
					$next.css("display", "flex");
					$swiperContainer.removeClass("swiper-disabled");
				}

				// фильтрация таблицы
				const $allRows = $(".price__table-body .price__item");
				let $filteredRows = $allRows;

				if (selectedCategory) {
					$filteredRows = $filteredRows.filter(function() {
						return $(this).attr("data-cat") === selectedCategory;
					});
				}

				if (selectedTonn) {
					$filteredRows = $filteredRows.filter(function() {
						let rowTonn = parseFloat($(this).attr("data-tonn")?.replace(",", ".").replace(/[^\d.]/g, ""));
						return !isNaN(rowTonn) && rowTonn === tonnNum;
					});
				}

				if (selectedBrand) {
					$filteredRows = $filteredRows.filter(function() {
						return $(this).attr("data-brand") === selectedBrand;
					});
				}

				$allRows.hide();
				$filteredRows.show();

				$(".price__table-body .no-results").remove();
				if ($filteredRows.length === 0) {
					$(".price__table-body").append('<tr class="no-results"><td colspan="3">Ничего не найдено</td></tr>');
				}
			},

			complete: function() {
				swiperInited = true;
				$("#spinner").fadeOut(200);
				$(".popular__list").fadeIn(200).promise().done(() => {
					initPopularSwiper();
				});
			},

			error: function() {
				alert("Ошибка запроса");
			}
		});
	});

  // Клик вне селекта — закрываем список
  $(document).click(function(e) {
    if (!$(e.target).closest(".select").length) {
      $(".select__head").removeClass("open");
      $(".select__list").fadeOut();
    }
  });
});

// подключаем select сортировки в модальном окне арендовать
jQuery(($) => {
	$(".popup__select").on("click", ".popup-select__head", function () {
		if ($(this).hasClass("open")) {
			$(this).removeClass("open");
			$(this).next().fadeOut();
		} else {
			$(".popup-select__head").removeClass("open");
			$(".popup-select__list").fadeOut();
			$(this).addClass("open");
			$(this).next().fadeIn();
		}
	});

	$(".popup__select").on("click", ".popup-select__item", function () {
		$(".popup-select__head").removeClass("open");
		$(this).parent().fadeOut();
		$(this).parent().prev().text($(this).text());
		$(this).parent().prev().prev().val($(this).text());
	});

	$(document).click(function (e) {
		if (!$(e.target).closest(".popup__select").length) {
			$(".popup-select__head").removeClass("open");
			$(".popup-select__list").fadeOut();
		}
	});
});

//map
ymaps.ready(function () {
	const doc = window.document;
	const currentURL = doc.URL;
	const url =
		currentURL.split("/")[0] +
		"//" +
		currentURL.split("/")[1] +
		currentURL.split("/")[2];
	//-http://alfa-rent.versus-ltd.org/

	var myMap = new ymaps.Map(
			"map",
			{
				center: [59.932076, 30.22486],
				zoom: 12,
			},
			{
				searchControlProvider: "yandex#search",
			}
		),
		// Создаём макет содержимого.
		MyIconContentLayout = ymaps.templateLayoutFactory.createClass(
			'<div style="color: #FFFFFF; font-weight: bold;">$[properties.iconContent]</div>'
		),
		myPlacemark = new ymaps.Placemark(
			myMap.getCenter(),
			{
				hintContent: "Санкт-Петербург, Шкиперский проток, д. 14, к. 8",
				balloonContent: "Альфа рент",
			},
			{
				// Опции.
				// Необходимо указать данный тип макета.
				iconLayout: "default#image",
				// Своё изображение иконки метки.
				iconImageHref: `${url}/media/icons/geo.svg`,
				// Размеры метки.
				iconImageSize: [37, 48],
				// Смещение левого верхнего угла иконки относительно
				// её "ножки" (точки привязки).
				iconImageOffset: [-5, -48],
			}
		);

	myMap.geoObjects.add(myPlacemark);
});

//tabs на главной работы и статьи
$(".articles__tab").on("click", function () {
	const btnId = $(this).attr("data-id");

	$(".articles__tab").removeClass("articles__tab-active");
	$(this).addClass("articles__tab-active");

	$(".articles__content").hide().filter(`[data-id="${btnId}"]`).fadeIn();
});

//tabs страница товара
$(".product-tabs__btn").on("click", function () {
	const btnId = $(this).attr("data-id");

	$(".product-tabs__btn").removeClass("product-tabs__btn-active");
	$(this).addClass("product-tabs__btn-active");

	$(".product-tabs__content").hide().filter(`[data-id="${btnId}"]`).fadeIn();
});

// photoswipe
function isPhonePortrait() {
	return window.matchMedia("(max-width: 600px) and (orientation: portrait)")
		.matches;
}
const lightbox = new PhotoSwipeLightbox({
	gallery: ".images-popup a",
	// initialZoomLevel: 'fit',
	// secondaryZoomLevel: 1.5,
	// maxZoomLevel: 1,

	// initialZoomLevel: 1,
	// secondaryZoomLevel: 3,
	// maxZoomLevel: 4,

	// initialZoomLevel: 2,
	// secondaryZoomLevel: 2.5,
	// maxZoomLevel: 3,

	initialZoomLevel: (zoomLevelObject) => {
		if (isPhonePortrait()) {
			return zoomLevelObject.vFill;
		} else {
			return 1;
		}
	},
	secondaryZoomLevel: (zoomLevelObject) => {
		if (isPhonePortrait()) {
			return zoomLevelObject.fit;
		} else {
			return 2.5;
		}
	},
	maxZoomLevel: 3,
	pswpModule: PhotoSwipe,
});
lightbox.init();

// const lightbox2 = new PhotoSwipeLightbox({
//   gallery: ".recommend-popup a",

//   initialZoomLevel: (zoomLevelObject) => {
//     if (isPhonePortrait()) {
//       return zoomLevelObject.vFill;
//     } else {
//       return 1;
//     }
//   },

//   initialZoomLevel: 0.4,
//   maxZoomLevel: 1,
//   pswpModule: PhotoSwipe,
// });
// lightbox2.init();

// const lightbox3 = new PhotoSwipeLightbox({
//   gallery: ".gallery-popup li a",

//   initialZoomLevel: (zoomLevelObject) => {
//     if (isPhonePortrait()) {
//       return zoomLevelObject.vFill;
//     } else {
//       return 1;
//     }
//   },

//   initialZoomLevel: "fit",
//   maxZoomLevel: 1,
//   pswpModule: PhotoSwipe,
// });
// lightbox3.init();

// таблица скрыть заголовки без контента

document.querySelectorAll(".chars-table thead + tbody").forEach((tbody) => {
	if (!tbody.children.length) {
		tbody.previousElementSibling.setAttribute("hidden", "");
	}
});


//калькулятор 

$(document).ready(function() {
  $("truck-calculator").on("formsubmit", function(e) {
    e.originalEvent.preventDefault();

    const formData = e.originalEvent.detail;
    formData.action = "calc";
    formData.slt_cats = "Автокраны";

    $.ajax({
      type: "POST",
      url: "/ajax.php?mid=1",
      dataType: "html",
      data: formData,
      success: function(data) {
        // Вставляем полученный HTML в контейнер калькулятора
        $("#calculatorResults").html(data);

        // Прокручиваем страницу к новому контенту
        $("html, body").animate({
          scrollTop: $("#calculatorResults").offset().top
        }, 1000);

        // Инициализируем слайдер внутри #calculatorResults, если он найден.
        // Здесь предполагается, что слайдер имеет класс .calculator-swiper,
        // а стрелки — .calculator-swiper-btn-next и .calculator-swiper-btn-prev.
        if ($("#calculatorResults .calculator-swiper").length) {
          new Swiper("#calculatorResults .calculator-swiper", {
            slidesPerView: "1",
            spaceBetween: 16,
            navigation: {
              nextEl: "#calculatorResults .calculator-swiper-btn-next",
              prevEl: "#calculatorResults .calculator-swiper-btn-prev"
            },
            breakpoints: {
              480: { slidesPerView: "2" },
              576: { slidesPerView: "3" },
              1024: { slidesPerView: "4" }
            }
          });
        }
      },
      error: function(e) {
        alert(e);
      }
    });
  });
});